import PropTypes from 'prop-types';

const UploadImage = ({ onChange }) => <div className="mb-4"><input type="file" id="imageUpload" accept="image/*" className="form-control" multiple onChange={(event) => onChange(Array.from(event.target.files || []))} /></div>;

UploadImage.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default UploadImage;
